<form [formGroup]="claimDataForm" *ngIf="accidentDetail">
  <div class="grid-col-3">
    <!-- Tipo de parte -->
    <div class="input-container">
      <span class="label">Tipo de parte</span>
      <div class="input">
        <input
          formControlName="tipoParte"
          type="text"
          placeholder="Tipo de parte"
        />
      </div>
    </div>
    <!-- Número siniestro -->
    <div class="input-container">
      <span class="label">Número siniestro</span>
      <div class="input">
        <input
          formControlName="numeroSiniestro"
          type="text"
          placeholder="Número siniestro"
        />
      </div>
    </div>
    <!-- Departamento -->
    <div class="input-container">
      <span class="label">Departamento</span>
      <div class="input">
        <input
          formControlName="departamento"
          type="text"
          placeholder="Departamento"
        />
        <i class="fas fa-chevron-down"></i>
      </div>
    </div>
    <!-- Lugar del accidente -->
    <div class="input-container">
      <span class="label">Lugar del accidente</span>
      <div class="input">
        <input
          formControlName="lugarAccidente"
          type="text"
          placeholder="Lugar del accidente"
        />
      </div>
    </div>
    <!-- Cruce señalizado -->
    <div class="input-container">
      <span class="label">Cruce señalizado</span>
      <div class="input">
        <input
          formControlName="cruceSenializado"
          type="text"
          placeholder="Cruce señalizado"
        />
      </div>
    </div>
    <!-- Responsabilidad del asegurado -->
    <div class="input-container">
      <span class="label">Responsabilidad del asegurado</span>
      <div class="input">
        <input
          formControlName="responsabilidadAsegurado"
          type="text"
          placeholder="Responsabilidad del asegurado"
        />
      </div>
    </div>
    <!-- Estado del tiempo -->
    <div class="input-container">
      <span class="label">Estado del tiempo</span>
      <div class="input">
        <input
          formControlName="estadoTiempo"
          type="text"
          placeholder="Estado del tiempo"
        />
      </div>
    </div>
    <!-- Estado semaforo -->
    <div class="input-container">
      <span class="label">Estado del semáforo</span>
      <div class="input">
        <input
          formControlName="estadoSemaforo"
          type="text"
          placeholder="Estado del semáforo"
        />
      </div>
    </div>
    <!-- Estado de la calzada -->
    <div class="input-container">
      <span class="label">Estado de la calzada</span>
      <div class="input">
        <input
          formControlName="estadoDeLaCalzada"
          type="text"
          placeholder="Estado de la calzada"
        />
      </div>
    </div>
    <!-- Denuncia policial -->
    <div class="input-container">
      <span class="label">Denuncia policial</span>
      <div class="input">
        <input
          formControlName="denunciaPolicial"
          type="text"
          placeholder="Denuncia policial"
        />
      </div>
    </div>
    <!-- Lesionados -->
    <div class="input-container">
      <span class="label">Lesionados</span>
      <div class="input">
        <input
          formControlName="lesionados"
          type="text"
          placeholder="Lesionados"
        />
      </div>
    </div>

    <!-- Espirometría -->
    <div class="input-container">
      <span class="label">Espirometría</span>
      <label class="custom-radio-button-container"
        >Si
        <input
          type="radio"
          formControlName="espirometria"
          [value]="true"
          name="espirometria"
        />
        <span class="checkmark"></span>
      </label>

      <label class="custom-radio-button-container"
        >No
        <input
          type="radio"
          formControlName="espirometria"
          [value]="false"
          name="espirometria"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
  <div class="subtitle"><i class="fas fa-user"></i>Datos del Denunciante</div>
  <div class="grid-col-3">
    <!-- Nombre -->
    <div class="input-container">
      <span class="label">Nombre</span>
      <div class="input">
        <input
          formControlName="datosDenuncianteNombre"
          type="text"
          placeholder="Nombre"
        />
      </div>
    </div>

    <!-- Apellido -->
    <div class="input-container">
      <span class="label">Apellido</span>
      <div class="input">
        <input
          formControlName="datosDenuncianteApellido"
          type="text"
          placeholder="Apellido"
        />
      </div>
    </div>

    <!-- Teléfono -->
    <div class="input-container">
      <span class="label">Teléfono</span>
      <div class="input">
        <input
          formControlName="datosDenuncianteTelefono"
          type="text"
          placeholder="Teléfono"
        />
      </div>
    </div>

    <!-- Tipo de documento -->
    <div class="input-container">
      <span class="label">Tipo de documento</span>
      <div class="input">
        <input
          formControlName="datosDenuncianteTipoDocumento"
          type="text"
          placeholder="Tipo de documento"
        />
      </div>
    </div>

    <!-- Nro. documento -->
    <div class="input-container">
      <span class="label">Nro documento</span>
      <div class="input">
        <input
          formControlName="datosDenuncianteDocumento"
          type="text"
          placeholder="Nro documento"
        />
      </div>
    </div>
  </div>

  <div class="subtitle"><i class="fas fa-user"></i>Datos del conductor</div>
  <div class="grid-col-3">
    <!-- Nombre -->
    <div class="input-container">
      <span class="label">Nombre</span>
      <div class="input">
        <input
          formControlName="datosConductorSiniestroNombre"
          type="text"
          placeholder="Nombre"
        />
      </div>
    </div>

    <!-- Apellido -->
    <div class="input-container">
      <span class="label">Apellido</span>
      <div class="input">
        <input
          formControlName="datosConductorSiniestroApellido"
          type="text"
          placeholder="Apellido"
        />
      </div>
    </div>

    <!-- Teléfono -->
    <div class="input-container">
      <span class="label">Teléfono</span>
      <div class="input">
        <input
          formControlName="datosConductorSiniestroTelefono"
          type="text"
          placeholder="Teléfono"
        />
      </div>
    </div>

    <!-- Tipo de documento -->
    <div class="input-container">
      <span class="label">Tipo de documento</span>
      <div class="input">
        <input
          formControlName="datosConductorSiniestroTipoDocumento"
          type="text"
          placeholder="Tipo de documento"
        />
      </div>
    </div>

    <!-- Nro. documento -->
    <div class="input-container">
      <span class="label">Nro documento</span>
      <div class="input">
        <input
          formControlName="datosConductorSiniestroDocumento"
          type="text"
          placeholder="Nro documento"
        />
      </div>
    </div>
  </div>
</form>
